// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__2855M","loaderOuter":"PageOverlayLoader_loaderOuter__1lER0"};